"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadBatchSchema = exports.loadJobSchema = exports.loadsQuerySchema = exports.loadJobParamsSchema = exports.uploadLoadBodySchema = exports.uploadLoadQuerySchema = exports.LOAD_JOB_STATUSES = exports.UPLOAD_SOURCE_TYPES = void 0;
// Wire shapes of Screen 8's upload and batch history (SPEC §8 Screen 8, §9 `/api/loads`, §3.3 `force=true`;
// D-970, D-971; J-040), served at `/api/v1/loads` and `/api/v1/loads/jobs/:jobId` (D-973). The uploaded
// file is the request body (`application/octet-stream`); no shape here carries a value from the file,
// only ids, codes, counts and the file name the uploader gave. Numbers are raw (SPEC §9).
const zod_1 = require("zod");
/** The source types an upload accepts: SPEC §3.1's organisation and benchmark loaders; F1 and F2 left with J-184. */
exports.UPLOAD_SOURCE_TYPES = [
    "ACO_MS_PARTICIPANTS",
    "ACO_MS_PROVIDERS",
    "CMS_BENCHMARKS",
    "HMX_GROUP_CONFIG",
];
exports.LOAD_JOB_STATUSES = ["QUEUED", "RUNNING", "COMPLETE", "FAILED"];
// No `.meta({ id })` on a querystring or params schema: @fastify/swagger expands parameters inline.
exports.uploadLoadQuerySchema = zod_1.z.object({
    sourceType: zod_1.z.enum(exports.UPLOAD_SOURCE_TYPES),
    /** Stored on the batch; a name only, never a path. */
    fileName: zod_1.z
        .string()
        .trim()
        .min(1)
        .max(255)
        .regex(/^[^/\\\p{Cc}]+$/u, "a file name without a path or control characters"),
    /** `core.load_batch.source_system`; omitted means the year's `default_source_system` (D-1001). */
    sourceSystem: zod_1.z.string().trim().min(1).max(64).optional(),
    /** SPEC §3.3: `true` reloads a file whose SHA-256 already has a live batch. */
    force: zod_1.z.enum(["true", "false"]).default("false"),
});
/** The request body: the file's bytes, `application/octet-stream`. */
exports.uploadLoadBodySchema = zod_1.z
    .custom((value) => Buffer.isBuffer(value) && value.length > 0, "a non-empty file")
    .meta({ type: "string", format: "binary" });
exports.loadJobParamsSchema = zod_1.z.object({ jobId: zod_1.z.uuid() });
exports.loadsQuerySchema = zod_1.z.object({
    year: zod_1.z.coerce.number().int().min(2000).max(2100).optional(),
    limit: zod_1.z.coerce.number().int().min(1).max(500).default(100),
});
const count = zod_1.z.number().int().min(0);
/** The batch a job's load wrote, with its counts once it is COMPLETE (SPEC §3.1). */
const loadJobBatchSchema = zod_1.z.object({
    batchId: zod_1.z.number().int(),
    status: zod_1.z.string(),
    rowsRead: count,
    rowsLoaded: count,
    rowsRejected: count,
});
exports.loadJobSchema = zod_1.z
    .object({
    jobId: zod_1.z.uuid(),
    sourceType: zod_1.z.string(),
    fileName: zod_1.z.string(),
    status: zod_1.z.enum(exports.LOAD_JOB_STATUSES),
    /** A reason code on FAILED (`DUPLICATE_FILE`, `MISSING_COLUMNS`, …); never a message or a value. */
    errorReason: zod_1.z.string().nullable(),
    /** ISO 8601. */
    createdAt: zod_1.z.string(),
    startedAt: zod_1.z.string().nullable(),
    finishedAt: zod_1.z.string().nullable(),
    batch: loadJobBatchSchema.nullable(),
})
    .meta({ id: "AcoLoadJob" });
/** One `core.load_reject.reason` code with the rejects that carry it. */
const loadRejectCountSchema = zod_1.z.object({ reason: zod_1.z.string(), rejects: count });
/** One `core.load_batch`, newest first: Screen 8's batch history. */
exports.loadBatchSchema = zod_1.z
    .object({
    batchId: zod_1.z.number().int(),
    /** The upload job that wrote it; null for a batch loaded with `pnpm load`. */
    jobId: zod_1.z.uuid().nullable(),
    sourceType: zod_1.z.string(),
    fileName: zod_1.z.string(),
    performanceYear: zod_1.z.number().int().nullable(),
    sourceSystem: zod_1.z.string().nullable(),
    isSynthetic: zod_1.z.boolean(),
    /** The uploading user's opaque id; null for a command-line load. */
    loadedBy: zod_1.z.string().nullable(),
    /** ISO 8601. */
    loadedAt: zod_1.z.string(),
    status: zod_1.z.string(),
    rowsRead: count,
    rowsLoaded: count,
    rowsRejected: count,
    /** Most rejects first, then by code. */
    rejectReasons: zod_1.z.array(loadRejectCountSchema),
})
    .meta({ id: "AcoLoadBatch" });
//# sourceMappingURL=loads.js.map